import { cities } from "../notifications/AddNotification"
import { compactSelectStyles, labelStyle, MultiSelectInput } from "./utils"
import Select from 'react-select';
import "./MultiSelect.css";
import { useGetGamesQuery } from "../../store/services/gameServices";
import { useEffect, useState } from "react";
import { useGetMunicipalitiesQuery } from "../../store/services/municipalitiesServices";

export const WinnersFilters = ({ multiSelectFilters, handleMultiSelectFiltersChange, multiSelectItems, handleMultiSelectItemsChange, rangeItems, handleRangeItemsChange, dropdownMultiSelectItems, handleDropdownMultiSelectChange, handleDeleteMultiSelectFilters, dropdownSelectItems, handleDropdownSelectChange }) => {

    const { personal_numbers, bank_account_numbers } = multiSelectItems
    const { game_id, tier_level } = dropdownSelectItems
    const { start_num_receipts, end_num_receipts, start_sum_with_vat, end_sum_with_vat, start_sum_without_vat, end_sum_without_vat } = rangeItems
    const { municipalities_no } = dropdownMultiSelectItems
    const { personal_numbers: selectedPersonalNumbers, bank_account_numbers: selectedBankAccountNumbers } = multiSelectFilters

    const [selectedGame, setSelectedGame] = useState({})
    const [tierOptions, setTierOptions] = useState([])

    const { data: gamesData } = useGetGamesQuery({})

    const { data: municipalities } = useGetMunicipalitiesQuery()

    useEffect(() => {
        if (gamesData?.data && gamesData?.data.data) {
            if (game_id) {
                setSelectedGame(gamesData?.data.data.find(game => game.game_id === game_id))
            }
        }
    }, [gamesData, game_id])

    useEffect(() => {
        if (selectedGame) {
            setTierOptions(selectedGame.tiers)
        }
    }, [selectedGame])

    useEffect(() => {
        console.log({ tierOptions })
    }, [tierOptions])

    return (
        <div className="flex flex-col gap-3">
            <MultiSelectInput
                type="number"
                name="personal_numbers"
                label="Numri personal"
                placeholder="Kerko sipas numrit personal"
                value={personal_numbers}
                handleValueChange={handleMultiSelectItemsChange}
                handleSelectedValuesChange={handleMultiSelectFiltersChange}
                selectedValues={selectedPersonalNumbers}
                handleDeleteMultiSelectFilters={handleDeleteMultiSelectFilters}
            />
            <MultiSelectInput
                type="number"
                name="bank_account_numbers"
                label="Numri i bankës"
                placeholder="Kerko sipas numrit të bankës"
                value={bank_account_numbers}
                handleValueChange={handleMultiSelectItemsChange}
                handleSelectedValuesChange={handleMultiSelectFiltersChange}
                selectedValues={selectedBankAccountNumbers}
                handleDeleteMultiSelectFilters={handleDeleteMultiSelectFilters}
            />
            <div className="flex flex-col gap-1.5">
                <label htmlFor="region" className={labelStyle}>Regjioni</label>
                <Select
                    isMulti
                    name="municipalities_no"
                    styles={compactSelectStyles}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    options={municipalities?.data.map(municipality => ({
                        value: municipality.municipality_no,
                        label: municipality.municipality_name
                    }))}
                    placeholder="Të gjitha regjionet"
                    onChange={handleDropdownMultiSelectChange}
                    value={municipalities?.data.filter(municipality => municipalities_no?.includes(municipality.municipality_no)).map(municipality => ({
                        value: municipality.municipality_no,
                        label: municipality.municipality_name
                    }))}
                />
            </div>
            <div className="flex flex-col gap-1.5">
                <label htmlFor="game_id" className={labelStyle}>Loja</label>
                <Select
                    name="game_id"
                    styles={compactSelectStyles}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    options={[
                        { value: null, label: 'Të gjitha lojerat' },
                        ...(gamesData?.data?.data.map(game => ({
                            value: game.game_id,
                            label: game.title
                        })) || [])
                    ]}
                    placeholder="Të gjitha lojerat"
                    onChange={handleDropdownSelectChange}
                    value={game_id ?
                        gamesData?.data?.data.find(game => game.game_id === game_id) ?
                            { value: game_id, label: gamesData?.data.data.find(game => game.game_id === game_id)?.title }
                            : undefined
                        : { value: null, label: 'Të gjitha lojerat' }}
                    isClearable={false}
                />
            </div>
            <div className="flex flex-col gap-1.5">
                <label htmlFor="tier_level" className={labelStyle}>Kushti</label>
                <Select
                    name="tier_level"
                    styles={compactSelectStyles}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    options={[
                        { value: null, label: 'Të gjitha nivelet' },
                        ...(tierOptions?.map((tier) => ({
                            value: tier.tier_level,
                            label: `Kushti ${tier.tier_level}`
                        })) || [])
                    ]}
                    placeholder="Të gjitha nivelet"
                    onChange={handleDropdownSelectChange}
                    value={(() => {
                        if (!tier_level) {
                            return { value: null, label: 'Të gjitha nivelet' };
                        }
                        const selectedIndex = tierOptions?.findIndex(tier => tier.tier_level === tier_level);
                        if (selectedIndex !== -1 && selectedIndex !== undefined) {
                            return {
                                value: tier_level,
                                label: `Kushti ${tier_level}`
                            };
                        }
                        return { value: null, label: 'Të gjitha nivelet' };
                    })()}
                    isClearable={false}
                />
            </div>
        </div>
    )
}